export interface User {
  firstName: string;
  lastName: string;
  userId: string;
}

export interface IBasicRole {
  delegationAllowed: boolean;
  roleName: string;
  targets: any;
}

export interface IUserRole {
  basicRoles: IBasicRole[];
  delegatedRoles: any[];
}

export interface LoggedUser extends User {
  office: string;
}

export interface IManagedUser {
  code: string;
  company: string;
  id?: string;
  uniqueId?: string;
  name: string;
  organizationalUnit: string;
  organizational_unit?: string;
  organizationalUnitCode: string;
  organizational_unit_code?: string;
  resp_code: string;
  respFullName: string;
  resp_full_name?: string;
  surname: string;
  type: string;
  mobileNumber?: string;
  mobileNumberVerified?: boolean;
  phoneNumber?: string;
  identitySystemId?: string;
}

export interface IUserInfo {
  code: string;
  company: string;
  id: string;
  name: string;
  language: string;
  organizational_unit: string;
  organizational_unit_code: string;
  resp_code: string;
  resp_full_name: string;
  roles: IUserRole;
  sections: string[];
  surname: string;
  type: string;
  email: string;
  mobileNumber: string;
  mobileNumberVerified: boolean;
  phoneNumber: string;
}

export enum UserSections {
  DELETE_BUSINESS_ROLE = "DELETE_BUSINESS_ROLE",
  ADM_SHOW_SEGREGATION = "ADM_SHOW_SEGREGATION",

  HISTORY_REQUEST = "HISTORY_REQUEST",
  EXAMINE_USERS = "EXAMINE_USERS",
  EXAMINE_ENTITLEMENTS = "EXAMINE_ENTITLEMENTS",
  USER_ENTITLEMENTS = "USER_ENTITLEMENTS",
  CATALOG = "CATALOG",
  USER_ENTITLEMENT_REQUEST = "USER_ENTITLEMENT_REQUEST",
  RACF_USER = "RACF_USER",
  DELEGATIONS = "DELEGATIONS",
  APPROVALS = "APPROVALS",
  TASK = "TASK",
  SERVICE_REQUEST = "SERVICE_REQUEST",
  REPORTS = "REPORTS",
  MANUALS = "MANUALS",
  EXTERNAL_PORTAL = "EXTERNAL_PORTAL",
  BUSINESS_ROLE = "BUSINESS_ROLE",
  PROFILE_MGMT = "PROFILE_MGMT",
  RESET_PWD = "RESET_PWD",
  CHANGE_PWD = "CHANGE_PWD",
  CREATE_CAMPAIGN = "CREATE_CAMPAIGN",
  EXAMINE_CAMPAIGN = "EXAMINE_CAMPAIGN",
  CONSOLE_ADMIN = "CONSOLE_ADMIN",
  TEMPORARY_ABILITATIONS = "TEMPORARY_ABILITATIONS",
  TECHNICAL_USERS = "TECHNICAL_USERS",
  EXTERNAL_PORTAL_USERS = "EXTERNAL_PORTAL_USERS",
  EXTERNAL_PORTAL_COMPANY = "EXTERNAL_PORTAL_COMPANY",
  ADM_USER_MGMT = "ADM_USER_MGMT",
  ADM_APP_ENT_MGMT = "ADM_APP_ENT_MGMT",
  ADM_CATALOG_MGMT = "ADM_CATALOG_MGMT",
  ADM_PWD_MGMT = "ADM_PWD_MGMT",
  ADM_EXTERNAL_PORTAL_MGMT = "ADM_EXTERNAL_PORTAL_MGMT",
  ADM_SOD_MGMT = "ADM_SOD_MGMT",
  ADM_SERVICE_REQ_MGMT = "ADM_SERVICE_REQ_MGMT",
  ADM_MANUALS_MGMT = "ADM_MANUALS_MGMT",
  ADM_REPORT_MGMT = "ADM_REPORT_MGMT",
  ADM_TEMPLATE_MGMT = "ADM_TEMPLATE_MGMT",
  ADM_SMS_TEMPLATE_MGMT = "ADM_SMS_TEMPLATE_MGMT",
  ADM_WORKFLOW_MGMT = "ADM_WORKFLOW_MGMT",
  ADM_TABLE_CONFIG_MGMT = "ADM_TABLE_CONFIG_MGMT",
  ADM_RECOVERY_MGMT = "ADM_RECOVERY_MGMT",
  ADM_PROFILES_MGMT = "ADM_PROFILES_MGMT",
  ADM_AUDIT_MGMT = "ADM_AUDIT_MGMT ",
  ADM_NOTIFY_MGMT = "ADM_NOTIFY_MGMT",
  ADM_RECERTIFICATION_CONFIGURATION = "ADM_RECERTIFICATION_CONFIGURATION",
  ADM_BR_MGMT = "ADM_BR_MGMT",
  ADM_FILE_MGMT = "ADM_FILE_MGMT",
  ADM_TEMPORARY_ABILITATIONS_MGMT = "ADM_TEMPORARY_ABILITATIONS_MGMT",
  ADM_UIGP_MGMT = "ADM_UIGP_MGMT",
  ADM_TECHNICAL_USERS_MGMT = "ADM_TECHNICAL_USERS_MGMT",
}
